export const getReportErrorParagraphString = (
  title: string,
  variable: string,
): string => {
  return `<p style="margin:5px 0;">${title}: ${variable}</p>`;
};
